import palette from 'theme/palette';
import { Tooltip } from '@mui/material';
import { withStyles } from '@mui/styles';
import theme from 'theme';

export const LightTooltip = withStyles(() => ({
  tooltip: {
    border: 'none',
    borderRadius: 0,
    boxShadow: `rgb(0 0 0 / 20%) 0px 5px 5px -3px, rgb(0 0 0 / 14%) 0px 8px 10px 1px, rgb(0 0 0 / 12%) 0px 3px 14px 2px`,
    backgroundColor: palette.white,
    color: palette.black,
    fontSize: 13,
    whiteSpace: 'pre-line',
    padding: theme.spacing(1.5),
    marginTop: theme.spacing(12),
    marginLeft: theme.spacing(-10),
  },
}))(Tooltip);
